import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { EventsService } from '../_services/events.service';
import { Mapapi } from '../ol-map/mapapi';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { GlobalsService } from '../_services/globals.service';
import { LayersService } from '../_services/layers.service';
import { Observable, Subject, BehaviorSubject, throwError } from 'rxjs';
import { ReportsService } from '../reports/reports.service';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { Subscription, interval } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { DistrictHeatingService } from 'app/_services/district-heating.service';
import { HttpClient } from '@angular/common/http';

type DistrictHeatingView = 'overview' | 'napoved' | 'zgodovina';
type FeatureInfoAction = 'none' | 'streetview' | 'zoom' | `extra:${string}`;

@Component({
    selector: 'app-feature-info',
    templateUrl: './feature-info.component.html',
    styleUrls: ['./feature-info.component.css'],
    standalone: false
})
export class FeatureInfoComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('tabViewEl', { read: ElementRef }) tabViewEl!: ElementRef;

    activeTabIndex = 0;
    attributes: any;
    keys: any;
    //   btnName: string;
    additionalButtons: Array<any> = []
    display: any = false;
    remotePowerBtn: boolean = false;
    deleteDrawnAreaBtn: boolean = false;
    stack: any[] = [];
    capabilities: any[] = [];
    columnDescriptions: Record<string, Record<string, string>> = {};
    columnDescriptionsLoading: Record<string, boolean> = {};
    columnLabels: Record<string, string> = {};
    
    constructor(
        private es: EventsService,
        private api: Mapapi,
        private sanitizer: DomSanitizer, 
        private gs: GlobalsService,
        private ls: LayersService,
        private remotePowerService: RemotePowerService, 
        private rs: ReportsService,
        private messageService: MessageService,
        private districtHeatingService: DistrictHeatingService,
        private http: HttpClient
    ) {}

    private scrollActiveTabIntoView(): void {
        setTimeout(() => {
            const host = this.tabViewEl?.nativeElement as HTMLElement;
            if (!host) return;

            const activeTab = host.querySelector(
            '.p-tablist .p-tab[aria-selected="true"]'
            ) as HTMLElement | null;

            if (!activeTab) return;

            activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

            this.refreshTabsArrowsSoon();
            requestAnimationFrame(() => {
            this.refreshTabsArrowsSoon();
            setTimeout(() => this.refreshTabsArrowsSoon(), 180);
            });
        }, 0);
    }

    private reportInProgress = false;

    private findTabIndexByFeature(f: any): number {
        const id = f?.getId?.();
        if (!id) return -1;
        return this.stack.findIndex(x => x?.feature?.getId?.() === id);
    }

    private activateTab(index: number): void {
        if (index < 0) return;
        this.display = true;

        setTimeout(() => {
        this.activeTabIndex = index;
        this.scrollActiveTabIntoView();
        this.refreshTabsArrowsSoon();
        }, 0);
    }


    private districtHeatingPolling: { [featureId: string]: Subscription } = {};

    public clearStack(): void {
        this.api.unselectAllFeatures();
        this.stack = [];
    }

    public setActiveAction(info: any, action: FeatureInfoAction): void {
        if (!info) return;
        info.activeAction = action;
    }

    public isActiveAction(info: any, action: FeatureInfoAction): boolean {
        return info?.activeAction === action;
    }

    public gsw(info: any): void {
        // toggle OFF
        if (info?.streetViewUrl) {
            info.streetViewUrl = undefined;

            // če hočeš odstraniti active stanje gumba
            if (info.activeAction === 'streetview') {
                info.activeAction = null;
            }
            return;
        }

        // toggle ON
        info.activeAction = 'streetview';

        if (!info?.feature?.getGeometry?.()) {
            console.warn('StreetView: feature geometry missing (after zoom?)', info);
            return;
        }

        const xy = this.api.getCenterOfFT(info.feature.getGeometry().getExtent());
        const url = this.gs.getStreetViewUrl() + xy[1] + "," + xy[0];

        info.streetViewUrl = undefined;
        setTimeout(() => {
            info.streetViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        });
    }

    public closeInfo(event: any): void {
        const closingInfo = this.stack[event.index];
        const closingFeatureId = this.getFeatureIdSafe(closingInfo?.feature);
        if (closingFeatureId) {
            this.stopDistrictHeatingPolling(closingFeatureId);
        }

        this.stack.splice(event.index, 1);

        if (this.stack.length === 0) {
            this.display = false;
            this.clearStack();
            this.activeTabIndex = 0;
            return;
        }

        // če zapreš tab pred trenutnim aktivnim, se index premakne levo
        if (this.activeTabIndex > event.index) {
            this.activeTabIndex--;
        }

        // če je active index zdaj čez konec, ga popravi
        if (this.activeTabIndex >= this.stack.length) {
            this.activeTabIndex = this.stack.length - 1;
        }
        this.refreshTabsArrowsSoon();
    }


    public aditionalBtnsController(btnControl: string, info: any): void {
        this.setActiveAction(info, `extra:${btnControl}`);

        switch (btnControl) {
            case "getTechBasicData":
                this.remotePowerBtnClicked(info);
                break;
            case "deleteCustomHeatingArea":
                this.deleteCustomHeatingArea(info);
                break;
            case "editCustomHeatingArea":
                this.editCustomHeatingArea(info);
                break;
            case "cancelCustomAreaCalc":
                this.cancelCustomAreaCalc(info);
                break;
            default:
                break;
        }
    }


    public remotePowerBtnClicked(info: any): void {
        console.warn("CLICKED remotePowerBtnClicked", info)
        this.es.emitOnRemoteBtnEmit(info);
        this.display = false;
    }


    public deleteCustomHeatingArea(infoEvent: any): void {
        console.log(infoEvent.attributes.id_ogrevalnega_sistema.split('.').join(""))
        this.remotePowerService.deleteCustomHeatingArea(Number(infoEvent.attributes.id_ogrevalnega_sistema.split('.').join(""))).subscribe({
            next: res => {
                console.log("Res", res)
            },
            error: err => {
                console.error(err)
                this.messageService.add({ key: 'featureInfoToast', severity: 'error', summary: 'Obvestilo', detail: 'Napaka :' + err._body });
            }
        })
    }

    public cancelCustomAreaCalc(info: any){
        this.remotePowerService.cancelCustomAreaCalc(Number(info.attributes.id_ogrevalnega_sistema.split('.').join(""))).subscribe({
            next: res => {
                this.messageService.add({ key: 'featureInfoToast', severity: 'info', summary: 'Obvestilo', detail: res._body });
            },
            error: err => {
                console.error(err)
                this.messageService.add({ key: 'featureInfoToast', severity: 'error', summary: 'Obvestilo', detail: 'Napaka :' + err._body });
            }
        })
    }

    public editCustomHeatingArea(infoEvent: any): void {
        this.es.emitEditArea(infoEvent);
        this.display = false;
    }

    private infoExists(i: any): boolean {
        for (let af of this.stack) {
            console.warn("infoExists", af.feature.getId(), i.getId())
            if (af.feature.getId() === i.getId()) {
                return true;
            }
        }
        return false;
    }

    public replaceAll(what: string, finds: string, withs: string) {
        return what.replace(new RegExp(finds, 'g'), withs);
    }

    public attrLabel(item: string): string {
        const direct = this.columnLabels[item];
        if (direct) return direct;

        if (item.startsWith('_')) {
            const stripped = this.columnLabels[item.substring(1)];
            if (stripped) return stripped;
        }

        return this.replaceAll(item, '_', ' ');
    }

    public findCapatibilityLayerTitle(name: string): string {

        for (let c of this.capabilities) {
            if (c.Name[0].split(":")[1] === name) {
                return c.Title[0];
            }
        }
        return name;
    }

    private santinizeToLocale(data: any) {
        return Object.keys(data).map(f => {
            return data[f] = this.toLocaleStr(data[f], f);

        });
    }

    private toLocaleStr(v: any, attrname: any): any {

        // && attrname.substr(0,1) !== "_" 
        if (v != null && !isNaN(v) && !(attrname === "leto" || attrname.includes("leto_") || attrname.includes("leto ")) && !attrname.includes("poštna") && attrname !== "_gid" && attrname !== "_id" && attrname !== "_na_mid" && attrname !== "_ob_mid") {
            return v.toLocaleString('sl');
        }
        else {
            return v;
        }
    }

    public openReport(param: string, locinfsid: any, rname: string): void {
        const TOAST_KEY = 'featureInfoToast';

        // prevent double clicks / multiple parallel calls
        if (this.reportInProgress) {
            this.messageService.clear(TOAST_KEY);
            this.messageService.add({
            key: TOAST_KEY,
            severity: 'info',
            summary: 'Obvestilo',
            detail: 'Poročilo je že v pripravi...'
            });
            return;
        }

        this.reportInProgress = true;

        // IMPORTANT: clear ONLY this toast area before adding (so no stacking)
        this.messageService.clear(TOAST_KEY);

        // show ONE loading toast
        this.messageService.add({
            key: TOAST_KEY,
            severity: 'info',
            summary: 'Obvestilo',
            detail: 'Poročilo v pripravi, prosimo počakajte...',
            sticky: true
        });

        const qs =
            `userLocale=de&reportLocale=de&${param}=${encodeURIComponent(String(locinfsid))}` +
            `&showreports=${encodeURIComponent(rname)}`;

        this.rs.exportFile(rname, 'pdf', qs)
            .pipe(
            finalize(() => {
                this.reportInProgress = false;
                // remove loading toast
                this.messageService.clear(TOAST_KEY);
            })
            )
            .subscribe({
            next: (d) => {
                this.rs.downloadFile(d, `${rname}.pdf`, 'pdf');

                // show ONE success toast (won't stack because we cleared in finalize)
                this.messageService.add({
                key: TOAST_KEY,
                severity: 'success',
                summary: 'Obvestilo',
                detail: 'Poročilo izdelano.',
                life: 2500
                });
            },
            error: (e) => {
                const detail = e?.error?.message || e?.message || e?._body || String(e);

                this.messageService.add({
                key: TOAST_KEY,
                severity: 'error',
                summary: 'Obvestilo',
                detail: 'Napaka: ' + detail,
                life: 6000
                });
            }
        });
    }


    public selectFeature(info: any): void {
        if (!info?.feature) return;

        info.activeAction = 'zoom';
        this.api.zoomToFeature(info.feature);
    }

    ngOnInit() {

        var self = this;

        this.ls.getWMSCap().subscribe({
            next: (xmlText: string) => {
            // Parse XML
            const doc = new DOMParser().parseFromString(xmlText, 'text/xml');

            // If XML is invalid, browsers produce <parsererror>
            const parserError = doc.getElementsByTagName('parsererror')[0];
            if (parserError) {
                console.error('Invalid XML', parserError.textContent);
                self.capabilities = [];
                return;
            }

            // Get: Capability > Layer (root layer)
            const capability = doc.getElementsByTagName('Capability')[0];
            const rootLayer = capability?.getElementsByTagName('Layer')[0];

            if (!rootLayer) {
                self.capabilities = [];
                return;
            }

            // Direct child <Layer> nodes (this corresponds to Layer[0].Layer in xml2js)
            const childLayers = Array.from(rootLayer.children).filter(
                (n) => n.nodeName === 'Layer'
            ) as Element[];

            // Convert them to a shape similar to xml2js result enough for your code
            self.capabilities = childLayers.map((layerEl) => ({
                Name: [layerEl.getElementsByTagName('Name')[0]?.textContent?.trim() ?? ''],
                Title: [layerEl.getElementsByTagName('Title')[0]?.textContent?.trim() ?? ''],
                Layer: [] // optional: fill recursively if you need nested layers
            }));

            // if you need nested layers too, tell me how you use capabilities and I’ll add recursion so it matches old structure
            },
            error: (e) => console.error('getWMSCap failed', e)
        });

        this.es.subscribeMidChangeEvtListener().subscribe
            (
                f => {
                    //console.log("changed ob mid feature-info component listener:"+f);
                    self.attributes = [];
                    self.keys = [];
                },
                e => {
                    console.log(e)
                });


        this.es.subscribeOlFeatureSelectListener().subscribe(f => {
            if (!f?.get("showinfo")) return;

            // If tab already exists -> just focus it
            const existingIndex = this.findTabIndexByFeature(f);
            if (existingIndex >= 0) {
                this.activateTab(existingIndex);
                return;
            }

            // Build new info (your existing code, shortened only where not needed)
            this.attributes = f.getProperties();

            const obMid = Number(
                String(this.attributes?._ob_mid ?? '').replace(/\./g, '')
            );

            if (obMid === 11027849) {
                this.loadColumnDescriptions('podatki_elek', 'javna_stavba_mol_agg_v');
}

            let reportname = null;
            let reportid = null;
            let reportlabel = null;
            let reportparam = null;

            if (this.attributes['_report_name'] !== undefined) {
                const rname = this.attributes['_report_name'];
                reportname  = rname.split("#")[0];
                const reportidfield = rname.split("#")[1];
                reportlabel = rname.split("#")[2];
                reportparam = reportidfield.replace('_', '');

                if (this.attributes[reportidfield] !== undefined) {
                reportid = this.attributes[reportidfield];
                }
            }

            // IMPORTANT: additionalButtons is global right now.
            // If it should be per-tab, move it into `info` instead.
            if (this.attributes._additional_info_button !== undefined) {
                const result = this.attributes['_additional_info_button'].split(';');
                this.additionalButtons = result.map((res: any) => {
                const btnName = res.split("#")[0];
                const btnControl = res.split("#")[1];
                return { btnName, btnControl };
                });
            } else {
                this.additionalButtons = [];
            }

            this.santinizeToLocale(this.attributes);
            this.keys = this.filterFeatureInfoKeys(f, Object.keys(this.attributes));

            const info = {
                attributes: this.attributes,
                keys: this.keys,
                feature: f,
                reportname,
                reportid,
                reportlabel,
                reportparam,
                dhView: 'overview' as DistrictHeatingView,
                dhLoading: this.isDistrictHeatingFeature(f),
                activeAction: 'none' as FeatureInfoAction,
                additionalButtons: this.attributes._additional_info_button
                ? this.attributes._additional_info_button.split(';').map((res: any) => {
                    const btnName = res.split("#")[0];
                    const btnControl = res.split("#")[1];
                    return { btnName, btnControl };
                    })
                : []
            };

            this.stack.push(info);
            this.startDistrictHeatingPolling(info);

            // Focus the newly created tab
            this.activateTab(this.stack.length - 1);
        });

        this.es.subscribeNodeUnSelectListener().subscribe(node => {
            var idx = 0;
            var rma: any[] = [];

            for (let info of this.stack) {
                const layerId = info?.feature?.get?.('layerID');
                const featureId = info?.feature?.getId?.()?.toString?.() || '';

                if (node.data.type == "wms") {
                    var ln = node.data.layer.split(":")[1];
                    var featureInfoExtractedLn = featureId.split(".")[0];
                    if (ln.includes(featureInfoExtractedLn)) {
                        rma.push(idx);
                    }
                }
                else if (node.data.type == "wfs") {
                    var ln = node.data.url.split("typeName=")[1].split("&")[0].split(":")[1];
                    var featureInfoExtractedLn = featureId.split(".")[0];
                    if (ln.includes(featureInfoExtractedLn)) {
                        rma.push(idx);
                    }
                }
                else if (node.data.type == "custom") {
                    if (layerId === node.data.id) {
                        rma.push(idx);
                    }
                }

                idx++;
            }

            rma.reverse();
            for (let i of rma) {
                this.stack.splice(i, 1);
            }

            if (this.stack.length === 0) {
                this.display = false;
            }
        });

        this.es.subscribeOlFeatureUnSelectListener().subscribe(f => {
            self.attributes = [];
            self.keys = [];

            const featureId = this.getFeatureIdSafe(f);
            if (featureId) {
                this.stopDistrictHeatingPolling(featureId);
            }
        });
    }

    private getText(parent: Element, tagName: string): string {
        const el = parent.getElementsByTagName(tagName)[0];
        return el?.textContent?.trim() ?? '';
    }

    public onVisChange(visible: boolean): void {
        if (!visible) {
            this.stopAllDistrictHeatingPolling();
            this.clearStack();
            this.display = false;
            this.messageService.clear();
            this.additionalButtons = [];
        }
    }
    public trackByFeatureId(index: number, info: any): string {
        // stabilen ID, da Angular ne rerenderja tabov po nepotrebnem
        return info?.feature?.getId?.() ?? String(index);
    }

    private navEl?: HTMLElement;
    private onScrollBound?: () => void;
    private ro?: ResizeObserver;

    ngAfterViewInit(): void {
        // Prime render je async, zato mali odlog
        setTimeout(() => this.hookTabScroll(), 0);
    }

    ngOnDestroy(): void {
        this.stopAllDistrictHeatingPolling();

        if (this.navEl && this.onScrollBound) {
            this.navEl.removeEventListener('scroll', this.onScrollBound);
        }
        this.ro?.disconnect();
    }

    private hookTabScroll(): void {
        const root = this.tabViewEl?.nativeElement as HTMLElement | undefined;
        if (!root) return;

        // scroll container za tab headerje
        const nav = root.querySelector<HTMLElement>('.p-tablist-nav-content');
        if (!nav) return;

        this.navEl = nav;

        const update = () => this.updateArrowClasses();
        this.onScrollBound = update;

        nav.addEventListener('scroll', update, { passive: true });

        // ob resize (dialog) se meje spremenijo
        this.ro = new ResizeObserver(() => this.updateArrowClasses());
        this.ro.observe(nav);

        // initial
        this.updateArrowClasses();
    }

    private updateArrowClasses(): void {
        const root = this.tabViewEl?.nativeElement as HTMLElement | undefined;
        const nav = this.navEl;
        if (!root || !nav) return;

        const maxScrollLeft = Math.max(0, nav.scrollWidth - nav.clientWidth);

        // toleranca zaradi sub-pixel + scrollbar
        const atStart = nav.scrollLeft <= 1;
        const atEnd = nav.scrollLeft >= (maxScrollLeft - 1);
        const noOverflow = maxScrollLeft <= 1;

        root.classList.toggle('fi-at-start', atStart || noOverflow);
        root.classList.toggle('fi-at-end', atEnd || noOverflow);
        root.classList.toggle('fi-no-overflow', noOverflow);
    }

    private refreshTabsArrowsSoon(): void {
        // počaka, da Angular/Prime rerenderja tab strip
        setTimeout(() => {
        // če še ni hook-an (npr. dialog se je ravno odprl)
        if (!this.navEl) this.hookTabScroll();
        this.updateArrowClasses();
        }, 0);
    }

    private isKotlovnica(info: any): boolean {
        const stavbaId =
            info?.districtHeatingData?.stavbaId ??
            info?.attributes?.stavbaId ??
            info?.feature?.get?.('stavbaId');

        return stavbaId != null && Number(stavbaId) === -1;
    }

    public getTabTitle(info: any): string {
        if (!info?.attributes) return '';

        const attrs = info.attributes;

        const layerId = info?.feature?.get?.('layerID');

        if (layerId === 'district-heating-lines') {
            if (attrs['naziv'] && String(attrs['naziv']).trim() !== '') {
                return `${attrs['naziv']}`;
            }
            return 'Sistem daljinskega ogrevanja';
        }

        if (layerId === 'district-heating-houses') {
            if (this.isKotlovnica(info)) {
                if (attrs['naslov'] && String(attrs['naslov']).trim() !== '') {
                    return String(attrs['naslov']);
                }
                return 'Kotlovnica';
            }

            if (attrs['stStavbe'] != null && String(attrs['stStavbe']).trim() !== '') {
                return `Stavba ${attrs['stStavbe']}`;
            }

            if (attrs['naslov'] && String(attrs['naslov']).trim() !== '') {
                return String(attrs['naslov']);
            }

            return 'Stavba';
        }

        // 1.1. če obstaja 'naziv'
        if (attrs['naziv'] && String(attrs['naziv']).trim() !== '') {
            return String(attrs['naziv']);
        }

        // 1.2. če obstaja 'naziv_stavbe'
        if (attrs['naziv_stavbe'] && String(attrs['naziv_stavbe']).trim() !== '') {
            return String(attrs['naziv_stavbe']);
        }

        // 2. poišči prvi stolpec ki vsebuje 'ime'
        const imeKey = Object.keys(attrs).find(k =>
            k.toLowerCase().includes('ime_') || k.toLowerCase().includes('ime_')
        );

        if (imeKey && attrs[imeKey]) {
            return String(attrs[imeKey]);
        }

        // če obstaja 'ime'
        if (attrs['ime'] && String(attrs['ime']).trim() !== '') {
            return String(attrs['ime']);
        }

        // 4. če obstaja 'upravljavec'
        if (attrs['upravljavec'] && String(attrs['upravljavec']).trim() !== '') {
            return String(attrs['upravljavec']);
        }

        // 7. če obstaja 'naslov'
        if (attrs['naslov'] && String(attrs['naslov']).trim() !== '') {
            return String(attrs['naslov']);
        }

        // 10. fallback (ime tabele)
        const layerName = info.feature?.getId?.()?.split('.')[0] || '';

        return layerName
            .replace(/^ren_/i, '')       // odstrani ren_ na začetku
            .replace(/\b\w/g, (c: any) => c.toUpperCase()) // velika začetnica
            .replace(/_v$/, '')       // odstrani _v na koncu
            .replace(/_/g, ' ');       // _ -> presledek
    }

    private filterFeatureInfoKeys(feature: any, keys: string[]): string[] {
        const hidden = ['geometry', 'showinfo', 'layerID', 'selected', 'raw'];

        if (this.isDistrictHeatingFeature(feature)) {
            return keys.filter(k => !hidden.includes(k));
        }

        return keys.filter(k => !hidden.includes(k));
    }
    
    public setDistrictHeatingView(info: any, view: DistrictHeatingView): void {
        if (!info) return;
        info.dhView = view;
    }

    public getDistrictHeatingView(info: any): DistrictHeatingView {
        return info?.dhView ?? 'overview';
    }

    private isDistrictHeatingFeature(f: any): boolean {
        const layerId = f?.get?.('layerID');
        return layerId === 'district-heating-lines' || layerId === 'district-heating-houses';
    }

    private getFeatureIdSafe(f: any): string | null {
        const id = f?.getId?.();
        return id != null ? String(id) : null;
    }

    private startDistrictHeatingPolling(info: any): void {
        const feature = info?.feature;
        if (!this.isDistrictHeatingFeature(feature)) return;

        const featureId = this.getFeatureIdSafe(feature);
        if (!featureId) return;

        this.stopDistrictHeatingPolling(featureId);

        this.districtHeatingPolling[featureId] = interval(20000).pipe(
            startWith(0),
            switchMap(() => {
                const layerId = feature?.get?.('layerID');

                if (layerId === 'district-heating-houses') {
                    const stavbaId = feature?.get?.('stavbaId');
                    const sistemId = feature?.get?.('sistemId');
                    return this.districtHeatingService.getHouseDetails(stavbaId, sistemId);
                }

                const systemId = feature?.get?.('sistemId') ?? featureId?.split('.').pop();
                return this.districtHeatingService.getSystemDetails(systemId);
            })
        ).subscribe({
            next: (data) => {
                if (!data) return;

                const layerId = feature?.get?.('layerID');

                // STAVBA ONLY
                if (layerId === 'district-heating-houses') {
                    const normalized = this.normalizeDistrictHeatingHouseData(data);

                    info.districtHeatingData = normalized;
                    info.dhLoading = false;

                    info.attributes = {
                        ...info.attributes,

                        tip: normalized.tip,
                        stavbaId: normalized.stavbaId,
                        stStavbe: normalized.stStavbe,
                        obMid: normalized.obMid,
                        koId: normalized.koId,
                        sistemId: normalized.sistemId,

                        naslov: normalized.naslov,
                        stevilka_toplotne_postaje: normalized.stevilka_toplotne_postaje,
                        nazivna_toplotna_moc_kw: normalized.nazivna_toplotna_moc_kw,
                        ocenjena_letna_raba_energije_kwh: normalized.ocenjena_letna_raba_energije_kwh,
                        ocenjeno_energetsko_st_stavbe_kwh_m2_leto: normalized.ocenjeno_energetsko_st_stavbe_kwh_m2_leto,
                        energetski_razred: normalized.energetski_razred,
                        povprecna_temperatura_v_stavbi_c: normalized.povprecna_temperatura_v_stavbi_c,
                        trenutna_vstopna_temperatura_c: normalized.trenutna_vstopna_temperatura_c,
                        trenutna_izstopna_temperatura_c: normalized.trenutna_izstopna_temperatura_c,
                        optimalna_temperatura_na_vstopu_c: normalized.optimalna_temperatura_na_vstopu_c,
                        ocenjen_prihranek_optimizacija_kwh: normalized.ocenjen_prihranek_optimizacija_kwh,
                        ocenjen_prihranek_znizanje_2k_kwh: normalized.ocenjen_prihranek_znizanje_2k_kwh,

                        cas_osvezeno: new Date().toLocaleTimeString('sl-SI')
                    };

                    this.santinizeToLocale(info.attributes);
                    info.keys = this.filterFeatureInfoKeys(feature, Object.keys(info.attributes));

                    const idx = this.findTabIndexByFeature(feature);
                    if (idx >= 0) {
                        this.stack[idx].attributes = info.attributes;
                        this.stack[idx].keys = info.keys;
                        this.stack[idx].districtHeatingData = normalized;
                        this.stack[idx].dhLoading = false;
                    }

                    console.log('District heating house info refreshed', featureId, normalized);
                    return;
                }

                // SISTEM - KEEP AS BEFORE
                info.districtHeatingData = data;
                info.dhLoading = false;

                info.attributes = {
                    ...info.attributes,
                    tip: data?.tip,
                    stavbaId: data?.stavbaId,
                    stStavbe: data?.stStavbe,
                    obMid: data?.obMid,
                    koId: data?.koId,
                    sistemId: data?.sistemId,
                    naziv: data?.naziv,
                    lastnik: data?.lastnik,
                    upravljalec: data?.upravljalec,
                    generator: data?.generator,
                    toplotni_vir: data?.toplotniVir,
                    energent: data?.energent,
                    ...(data?.osnovniPodatki || {}),
                    cas_osvezeno: new Date().toLocaleTimeString('sl-SI')
                };

                this.santinizeToLocale(info.attributes);
                info.keys = this.filterFeatureInfoKeys(feature, Object.keys(info.attributes));

                const idx = this.findTabIndexByFeature(feature);
                if (idx >= 0) {
                    this.stack[idx].attributes = info.attributes;
                    this.stack[idx].keys = info.keys;
                    this.stack[idx].districtHeatingData = data;
                    this.stack[idx].dhLoading = false;
                }

                console.log('District heating system info refreshed', featureId, data);
            },
            error: (err) => {
                info.dhLoading = false;
                console.error('District heating polling failed for feature', featureId, err);
            }
        });
    }

    private stopDistrictHeatingPolling(featureId: string): void {
        if (this.districtHeatingPolling[featureId]) {
            this.districtHeatingPolling[featureId].unsubscribe();
            delete this.districtHeatingPolling[featureId];
        }
    }

    private stopAllDistrictHeatingPolling(): void {
        Object.keys(this.districtHeatingPolling).forEach(featureId => {
            this.stopDistrictHeatingPolling(featureId);
        });
    }

    public isDistrictHeatingInfo(info: any): boolean {
        return !!info?.districtHeatingData;
    }

    public getNapovedColumns(info: any): string[] {
        const data = info?.districtHeatingData?.napoved?.urniPodatki || [];
        const times: string[] = [...new Set<string>(data.map((x: any) => String(x.cas)))];
        times.sort();
        return times;
    }

    public getZgodovinaColumns(info: any): string[] {
        const data = info?.districtHeatingData?.zgodovina?.podatki || [];
        const times: string[] = [...new Set<string>(data.map((x: any) => String(x.cas)))];
        times.sort();
        return times;
    }

    public buildNapovedRows(info: any): any[] {
        const data = info?.districtHeatingData?.napoved?.urniPodatki || [];
        const rowsMap = new Map<string, any>();

        data.forEach((x: any) => {
            const key = (x.naziv || '') + '|' + (x.vrsta || '');
            if (!rowsMap.has(key)) {
                rowsMap.set(key, {
                    naziv: x.naziv,
                    vrsta: x.vrsta,
                    enota: x.enota
                });
            }
            rowsMap.get(key)[x.cas] = x.vrednost;
        });

        return Array.from(rowsMap.values());
    }

    public buildZgodovinaGroups(info: any): any[] {
        const data = info?.districtHeatingData?.zgodovina?.podatki || [];
        const columns = this.getZgodovinaColumns(info);
        const groups = new Map<string, any>();

        data.forEach((x: any) => {
            const naziv = x.naziv || '';

            if (!groups.has(naziv)) {
                groups.set(naziv, {
                    naziv,
                    enota: x.enota,
                    rows: new Map<string, any>()
                });
            }

            const group = groups.get(naziv);

            if (!group.rows.has(x.vrsta)) {
                group.rows.set(x.vrsta, {
                    vrsta: x.vrsta
                });
            }

            group.rows.get(x.vrsta)[x.cas] = x.vrednost;
        });

        return Array.from(groups.values()).map(g => {
            const existingTypes = Array.from(g.rows.keys());

            // če obstaja modelirana, prikaži modelirana
            // sicer prikaži napovedana
            const thirdType = existingTypes.includes('Modelirana') ? 'Modelirana' : 'Napovedana';

            const wantedTypes = ['Merjena', 'Nastavljena', thirdType];

            const completedRows = wantedTypes.map(type => {
                const existingRow = g.rows.get(type) || { vrsta: type };

                // za vse stolpce zagotovi vrednost; če manjka, ostane undefined
                // v HTML se bo to prikazalo kot np
                columns.forEach(col => {
                    if (!(col in existingRow)) {
                        existingRow[col] = undefined;
                    }
                });

                return existingRow;
            });

            return {
                naziv: g.naziv,
                enota: g.enota,
                rows: completedRows
            };
        });
    }

    public buildDnevneRows(info: any): any[] {
        const data = info?.districtHeatingData?.napoved?.dnevniPodatki || [];
        const rowsMap = new Map<string, any>();

        data.forEach((x: any) => {
            const naziv = x.naziv;
            const datum = x.datum;
            if (!rowsMap.has(naziv)) {
                rowsMap.set(naziv, {
                    naziv: naziv,
                    enota: x.enota
                });
            }
            rowsMap.get(naziv)[datum] = x.vrednost;
        });

        return Array.from(rowsMap.values());
    }

    public getDnevniColumns(info: any): string[] {
        const data = info?.districtHeatingData?.napoved?.dnevniPodatki || [];
        const cols: string[] = [...new Set<string>(data.map((x: any) => String(x.datum)))];
        cols.sort();
        return cols;
    }

    private normalizeDistrictHeatingHouseData(data: any): any {
        const osnovni = data?.osnovniPodatki;

        return {
            ...data,

            // keep original backend data too
            osnovniPodatki: osnovni,

            // flatten for existing UI / attributes rendering
            naslov: osnovni?.naslov,
            stevilka_toplotne_postaje: osnovni?.stevilka_toplotne_postaje,
            nazivna_toplotna_moc_kw: osnovni?.nazivna_toplotna_moc_kw,
            ocenjena_letna_raba_energije_kwh: osnovni?.ocenjena_letna_raba_energije_kwh,
            ocenjeno_energetsko_st_stavbe_kwh_m2_leto: osnovni?.ocenjeno_energetsko_st_stavbe_kwh_m2_leto,
            energetski_razred: osnovni?.energetski_razred,
            povprecna_temperatura_v_stavbi_c: osnovni?.povprecna_temperatura_v_stavbi_c,
            trenutna_vstopna_temperatura_c: osnovni?.trenutna_vstopna_temperatura_c,
            trenutna_izstopna_temperatura_c: osnovni?.trenutna_izstopna_temperatura_c,
            optimalna_temperatura_na_vstopu_c: osnovni?.optimalna_temperatura_na_vstopu_c,
            ocenjen_prihranek_optimizacija_kwh: osnovni?.ocenjen_prihranek_optimizacija_kwh,
            ocenjen_prihranek_znizanje_2k_kwh: osnovni?.ocenjen_prihranek_znizanje_2k_kwh
        };
    }

    public isDistrictHeatingSystem(info: any): boolean {
        const layerId = info?.feature?.get?.('layerID');

        return info?.districtHeatingData?.tip === 'SISTEM'
            || layerId === 'district-heating-lines'
            || (layerId === 'district-heating-houses' && this.isKotlovnica(info));
    }

    public isDistrictHeatingHouse(info: any): boolean {
        const layerId = info?.feature?.get?.('layerID');

        return (
            info?.districtHeatingData?.tip === 'STAVBA'
            || layerId === 'district-heating-houses'
        ) && !this.isKotlovnica(info);
    }

    public getHouseOsnovni(info: any): any {
        return info?.districtHeatingData?.osnovniPodatki;
    }


    // Slovenska oblika števil
    public formatSlDate(value: any): SafeHtml {
        if (value === null || value === undefined || value === '') {
            return 'np';
        }

        const normalized = String(value).replace(' ', 'T');
        const date = new Date(normalized);

        if (isNaN(date.getTime())) {
            return String(value);
        }

        const d = new Intl.DateTimeFormat('sl-SI', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(date);

        const t = new Intl.DateTimeFormat('sl-SI', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);

        return this.sanitizer.bypassSecurityTrustHtml(`${d}<br>${t}`);
    }

    public formatSlNumber(value: any): string {
        if (value === null || value === undefined || value === '') {
            return 'np';
        }

        if (typeof value === 'number') {
            return new Intl.NumberFormat('sl-SI', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(value);
        }

        const str = String(value).trim();

        // don't try to format dates
        if (str.includes('-') && str.includes(':')) {
            return str;
        }

        const normalized = str.replace(',', '.');
        const num = Number(normalized);

        if (!isNaN(num) && normalized !== '') {
            return new Intl.NumberFormat('sl-SI', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(num);
        }

        return str;
    }


    private readonly MOL_EOL_FOLDER = 'EOL';
    private readonly MOL_OVE_FOLDER = 'SE';

    private normDir(s: any): string {
        return String(s ?? '')
            .replace(/\\/g, '/')
            .replace(/^\/+|\/+$/g, '')
            .replace(/\/{2,}/g, '/')
            .trim();
    }

    public isMolProjectInfoColumn(field: string, info: any): boolean {
        const obMid = Number(String(info?.attributes?._ob_mid ?? '').replace(/\./g, ''));

        return obMid === 11027849
            && (
                field === 'eol_projekt' ||
                field === 'ove_projekt' ||
                field === 'energetske_izkaznice'
            )
            && !!info?.attributes?._documents_folder;
    }

    public onMolProjectInfoColumnClick(info: any, field: string, event?: MouseEvent): void {
        if (!this.isMolProjectInfoColumn(field, info)) return;

        event?.stopPropagation();

        const payload: any = {
            documentsFolder: info.attributes._documents_folder,
            obMid: 11027849,
            houseName: info.attributes.naziv_stavbe || info.attributes.naziv || ''
        };

        switch (field) {
            case 'eol_projekt':
                payload.folderPath = this.MOL_EOL_FOLDER;
                break;

            case 'ove_projekt':
                payload.folderPath = this.MOL_OVE_FOLDER;
                break;

            case 'energetske_izkaznice':
                payload.previewFileNameLike = 'energetska izkaznica';
                break;

            default:
                return;
        }

        this.es.emitOpenMolDocs(payload);
    }

    private getColumnDescriptionKey(schema: string, tableName: string): string {
        return `${schema}.${tableName}`;
    }

    private loadColumnDescriptions(schema: string, tableName: string): void {
        const key = this.getColumnDescriptionKey(schema, tableName);

        if (this.columnDescriptions[key] || this.columnDescriptionsLoading[key]) return;

        this.columnDescriptionsLoading[key] = true;

        const url =
            `${this.gs.getRestUrl()}/api/tablecolumndescription/` +
            `${encodeURIComponent(schema)}/` +
            `${encodeURIComponent(tableName)}`;

        this.http.get<any>(url).subscribe({
            next: (res) => {
                const rows = Array.isArray(res)
                    ? res
                    : res?.tableColumnDescription || [];

                const map: Record<string, string> = {};

                rows.forEach((r: any) => {
                    const columnName = r.columnName || r.column_name;
                    const opis = r.description || r.opis;

                    if (columnName && opis) {
                        map[columnName] = opis;
                    }

                    if (columnName && r.label) {
                        this.columnLabels[columnName] = r.label;
                    }
                });

                this.columnDescriptions[key] = map;
                this.columnDescriptionsLoading[key] = false;
            },
            error: () => {
                this.columnDescriptions[key] = {};
                this.columnDescriptionsLoading[key] = false;
            }
        });
    }

    getFeatureInfoColumnHoverText(item: string, info: any): string {

        const obMid = Number(
            String(info?.attributes?._ob_mid ?? '').replace(/\./g, '')
        );

        if (obMid !== 11027849) {
            return '';
        }

        const key = this.getColumnDescriptionKey(
            'podatki_elek',
            'javna_stavba_mol_agg_v'
        );

        return this.columnDescriptions?.[key]?.[item] || '';
    }

}
